import { Shark, Utils, View } from "shark-mvc";
import moment from "moment";

// import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import applicatorTeamManager from "../../_shark_jaws/managers/applicatorTeamManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import contactFinderComponent from "../../components/contactFinder/contactFinderComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { documentManager } from "../../_shark_jaws/managers/documentManager";

// Dave.ToDo: Bisogna andare avanti a spostare qui i comportamenti comuni alle due View SI.
class SiteInfoSheetEditViewBase extends View {
	constructor (name) {
		super(name);
	}

	beforeLoadCommon (siteInfoSheetType) {
		window.scrollTo(0, 0);
		waitBoxComponent.open();
	
		const currUser = Shark.get("currUser");
		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			applicatorTeamManager.getList();
		}
	
		//Dave: non serve più perché non scarichiamo la lista Client.
		// let agentForClientList;
		
		// if (currUser.hasRole("areaManager")) {
		// 	const selectedAgent = agentFilterComponent.getSelectedAgent();
		// 	if (selectedAgent) {
		// 		agentForClientList = selectedAgent;
		// 	}
		// 	else {
		// 		agentForClientList = currUser;
		// 	}
		// }
		// else {
		// 	agentForClientList = currUser;
		// }

		this.set({
			currClient: Shark.get("editingClient"),
			__todayISO: moment().format(Shark.get("dtIsoDate"))
		});

		let currSiteInfoSheet = Shark.get("currSiteInfoSheet");

		//DAve: Probabilmente devo fare TUTTO solo se ho la SIS, se no non serve, tanto ritorno alla lista
		if (currSiteInfoSheet) {
			if (currSiteInfoSheet.guid !== "") {
				//Dave: Presumo che questo serva solo sul "Display" perché ad Edit ci arrivo solo da Display. (Ma se in futuro metto un "edit" direttamente dalla lista servirà... magari trovo il modo di capire se è completo o no...)
				siteInfoSheetManager.getByGuid(currSiteInfoSheet.guid, currSiteInfoSheet)
				.then(getByGuidResponse => {
					console.log({getByGuidResponse});

					this.set({
						__editEnabled: ![1, 4].includes(currSiteInfoSheet.extraData.quotation.status),
						// __editEnabled: [1, 4].indexOf(currSiteInfoSheet.extraData.quotation.status) === -1,
					});

					documentManager.getByGuidList2(currSiteInfoSheet.attachmentsGuids)
					.then(getDocumentListResponse => {
						currSiteInfoSheet.matchAttachmentsWithDocuments(getDocumentListResponse.data);
						waitBoxComponent.close();
						Shark.render();
					});
				});
			}
			// else {
			// 	waitBoxComponent.close();
			// }
			
			contactDetailsModalComponent.set("referenceDocument", currSiteInfoSheet);

			exportPDFComponent.set("documentSaveName", "Scheda Informativa - " + currSiteInfoSheet.registry.clientName + " - " + currSiteInfoSheet.registry.siteLocation.name + (currSiteInfoSheet.registry.siteLocation.interventionAreas !== "" ?  " - " + currSiteInfoSheet.registry.siteLocation.interventionAreas : ""));
			exportPDFComponent.set("documentToExport", currSiteInfoSheet);
		}
		else {
			waitBoxComponent.close();
		}
	}

	cancelEdits () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

		if (!currSiteInfoSheet.isDirty() || (currSiteInfoSheet.isDirty() && confirm("Sei sicuro di voler annullare? Le modifiche apportate andranno perse."))) {
			currSiteInfoSheet.restore();
			const cancelEditsDestination = this.get("cancelEditsDestination");

			if (cancelEditsDestination && cancelEditsDestination !== "") {
				Shark.openPage(cancelEditsDestination);
			}
			else {
				Shark.set({
					isEditingSiteInfoSheet: false,
				});

				Shark.render();
			}
		}
	}

	copyDataFromContact (contactType) {
		if (contactType && contactType.trim() !== "") {
			waitBoxComponent.open();

			const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
			const contactGuid = currSiteInfoSheet.registry[`${contactType}Guid`];

			clientManager.getByGuid(contactGuid)
			.then(response => {
				const contact = response.data;
				
				if (currSiteInfoSheet.copyDataFromContact(contact)) {
					waitBoxComponent.close();
					Shark.render();
				}
				else {
					waitBoxComponent.close();
				}
			});
		}
	}

	deletePictureBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler eliminare questo allegato?\nNon sarà possibile annullare!")) {
			const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
			const attachments = currSiteInfoSheet.__attachments;
			const attachment = Utils.safp(attachments, "guid", data.guid);

			if (attachment) {
				if (typeof attachment.set === "function") {
					attachment.set({
						__deletePending: true,
					});
				}
				else {
					attachment.__deletePending = true;
				}
			}

			//Dave: fin quando non processo tutte le SIS nel DB, devo eliminare anche le picture
			const pictures = currSiteInfoSheet.pictures;
			const index = Utils.safp(pictures, "guid", data.guid, "index");

			if (index > -1) {
				pictures.splice(index, 1);
			}

			currSiteInfoSheet.__dirtyProperties.push({ property: "__attachments", originalValue: [...attachments] });

			Shark.render();
		}
	}

	parseFormForEditing () {
		//Dave: Ti prego, facciamone una funzione
		const inputList = document.querySelectorAll("input");
		inputList.forEach(item => {
			item.disabled = false;
			item.readOnly = false;
			item.classList.remove("form-control-plaintext", "col-form-value");
			item.classList.add("form-control");
		});

		const selectList = document.querySelectorAll("select");
		selectList.forEach(item => {
			item.disabled = false;
			item.readOnly = false;
			item.classList.remove("form-control-plaintext", "col-form-value");
			item.classList.add("form-control");
		});

		const textareaList = document.querySelectorAll("textarea");
		textareaList.forEach(item => {
			item.disabled = false;
			item.readOnly = false;
			item.classList.remove("form-control-plaintext", "col-form-value");
			item.classList.add("form-control");
		});

		const addPremiseDestinationBtn = document.querySelector("#addPremiseDestinationBtn");
		if (addPremiseDestinationBtn) {
			addPremiseDestinationBtn.classList.remove("d-none");
		}

		const addSystemBtns = document.querySelectorAll(".addSystemBtn");
		addSystemBtns.forEach(item => {
			item.classList.remove("d-none");
		});
		const removePremiseDestinationBtns = document.querySelectorAll(".removePremiseDestinationBtn");
		removePremiseDestinationBtns.forEach(item => {
			item.classList.remove("d-none");
		});
		const removeSystemBtns = document.querySelectorAll(".removeSystemBtn");
		removeSystemBtns.forEach(item => {
			item.classList.remove("d-none");
		});

		const uploadPictureBtn = document.querySelector("#uploadPictureBtn");
		if (uploadPictureBtn) {
			uploadPictureBtn.classList.remove("d-none");
		}
	}

	removeContactReference (contactType) {
		if (contactType && confirm("Sei sicuro di voler disassociare questo contatto dalla Scheda Informativa?")) {
			const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

			if (currSiteInfoSheet) {
				currSiteInfoSheet.set({
					[`${contactType}Guid`]: "",
					[`registry.${contactType}Guid`]: "",
					[`registry.${contactType}Name`]: "",
					[`__${contactType}Name`]: "",
				});
				return true;
			}
		}
		return false;
	}

	setContactFromContactFinderForRole () {
		console.log("setContactForRole", {selectedContact});
		console.log(contactFinderComponent.__store);

		const selectedContact = contactFinderComponent.get("selectedContact");

		if (selectedContact) {
			const requestedContactType = contactFinderComponent.get("requestedContactType");

			if (requestedContactType !== "") {
				const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

				currSiteInfoSheet.set({
					[`${requestedContactType}Guid`]: selectedContact.guid,
					[`registry.${requestedContactType}Guid`]: selectedContact.guid,
					[`registry.${requestedContactType}Name`]: selectedContact.name,
					[`__${requestedContactType}Name`]: selectedContact.name,
				});

				Shark.render();
			}
		}
	}

	uploadedImage_changeHandler (event) {
		siteInfoSheetManager.uploadPicture(event.target);
	}

	uploadPictureBtn_clickHandler () {
		document.querySelector("#uploadedImage").click();
	}
}

export default SiteInfoSheetEditViewBase;
